import axios from 'axios';
import config from '../config';

const baseURL = `${config.api.host}:${config.api.port}/`;

const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
    },
});

export default axiosInstance;